import { render, staticRenderFns } from "./OpenSyllabusFileButton.vue?vue&type=template&id=68fd84b2&scoped=true&"
import script from "./OpenSyllabusFileButton.vue?vue&type=script&lang=ts&"
export * from "./OpenSyllabusFileButton.vue?vue&type=script&lang=ts&"
import style0 from "./OpenSyllabusFileButton.vue?vue&type=style&index=0&id=68fd84b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd84b2",
  null
  
)

export default component.exports